import { connect } from 'react-redux';
import CreateCommodity from '../components/create-commodity-component';
import {showAddComMod} from '../action-creators/create-commodity';
import {closeAddComMod} from '../action-creators/create-commodity';


const mapDispatchToProps = (dispatch, props) =>({
	showAddComModal: () => dispatch(showAddComMod('')),
	closeAddComModal: () => dispatch(closeAddComMod('')) 
});

const mapStateToProps =(state) => {
	 console.log(`mapStateToProps -> ${JSON.stringify(state.comModaldata)}`);
    return {
        comModVal:state.comModaldata.comModVal
     };
}

export default connect(
    mapStateToProps, 
    mapDispatchToProps
)(CreateCommodity);
